export const csvHeaders = [
  { label: "Redemption Id", key: "id" },
  { label: "User ID", key: "createdById" },
  { label: "User Email", key: "userEmail" },
  { label: "Broker Statement Name", key: "proofOfOwnershipName" },
  { label: "Redemption Date", key: "redemptionDate" },
  { label: "Processed Date", key: "processedDate" },
  { label: "Booking First Name", key: "bookingFirstName" },
  { label: "Booking Last Name", key: "bookingLastName" },
  { label: "Booking Number", key: "bookingId" },
  { label: "Sail Date", key: "bookingEventDate" },
  { label: "Ship Name", key: "cclShipName" },
  { label: "Brand", key: "perkName" },
  { label: "Status", key: "status" },
  { label: "Onboard Credit", key: "onboardCredit" },
  { label: "Invalidation Reason", key: "invalidationReason" },
  { label: "Invalidation Details", key: "invalidationDetails" },
  { label: "Updated By", key: "updatedByEmail" },
]
